// extracted by mini-css-extract-plugin
export var text = "_v-0";